import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import ViewTitle from '../../../components/ejected/ViewTitle';
import ListStatistics from '../../../components/ListStatistics';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between'
  },
};

export const Header = ({
  classes,
  className,
  title,
  total
}) => (
  <div>
    <div className={classnames(classes.root, className)}>
      <ViewTitle title={title} />
    </div>
    {/*<div>*/}
    {/*  <ListStatistics total={aggregationParams.count} accept={aggregationParams.verified} visited={aggregationParams.visited} result={aggregationParams.treaty} />*/}
    {/*</div>*/}
  </div>
);

Header.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.any,
  total: PropTypes.number.isRequired
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/pages/admin/statistics_company/Header.js